import i18n from "i18next";

export { T } from "./t";
export { useTranslation } from "react-i18next";
export { ALL_LOCALES, DEFAULT_LOCALE, LOCALE_NAMES, LOCALES } from "./locales";
export type { Locale } from "./locales";
export { LocalizationProvider } from "./localization-provider";

export function t(
  key: string,
  options?: Record<string, unknown>,
): string {
  return i18n.t(key, options);
}
